import React, { useEffect, useState } from "react";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
import InvoiceCard from "./InvoiceCard";
import BookingGetters from "../../store/onlineBooking/getters";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";

export default function MyInvoices() {
  const AppSettings = BookingGetters.getAppSettings();
  const [showInvoices, setShowInvoices] = useState(false);

  const isSmallScreen = window.innerWidth <= 768;
  const istabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;

  useEffect(() => {
    setShowInvoices(!!AppSettings?.reservedArea);
  }, [AppSettings]);

  if (!showInvoices) return <div />;

  return (
    <div
      className="flex-row md:flex"
      style={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}
    >
      {/* Sidebar — desktop only */}
      {!isSmallScreen && !istabletScreen && (
        <div style={{ width: "260px", flexShrink: 0 }}>
          <BookingDetalisListSideNavigation />
        </div>
      )}

      {/* Collapsible navbar — mobile / tablet */}
      {(isSmallScreen || istabletScreen) && (
        <CollapsibleNavbar callFrom="showReservations" />
      )}

      {/* Main content */}
      <div
        style={{
          flex: 1,
          padding: isSmallScreen ? "12px" : "",
          minWidth: 0,
        }}
      >
        <InvoiceCard />
      </div>
    </div>
  );
}
